module.exports = __webpack_public_path__ + "img/ch86.f29f212d.jpg";